import React, { useState, useCallback, useEffect } from 'react';
import { css } from 'styled-components';
import Layout from 'src/components/common/theme/Layout';
import {
  UitkMenu,
  UitkMenuTrigger,
  UitkMenuContainer,
  PositionType,
  UitkMenuList,
  UitkMenuIconTrigger,
} from 'uitk-react-menu';
import { UitkIconSize } from 'uitk-react-icons';
import { useStores } from 'src/utils/useStore';
import { getStore } from 'src/utils/store-utils';

import { checkValue } from 'src/components/common/helper';
import { randamizingNavItems } from './helper';

export const BurgerMenu: React.FC<any> = () => {
  const [isWhowMenu, setIsWhowMenu] = useState(false);
  const [menuIcon, setMenuIcon] = useState('menu');

  const {
    cpcmslitefeed: { spotlightPageData, conciergePageData, cpCmsLitePageData },
  } = useStores();

  const getURLPath = (url, pathportion) => {
    let subPath = '';
    if (checkValue(url)) {
      const path = url.split('?')[0];
      if (checkValue(path)) {
        const tempPath = path.replace(/\/$/, '');
        if (pathportion === 'end') {
          subPath = tempPath.substring(tempPath.lastIndexOf('/') + 1);
        }
      }
    }
    return subPath;
  };

  useEffect(() => {
    const icon = !isWhowMenu ? 'menu' : 'close';
    setMenuIcon(icon);
  }, [isWhowMenu]);

  const getBurgerMenuNavData = () => {
    let partnerHeaderNavigation = checkValue(cpCmsLitePageData)
      ? cpCmsLitePageData?.partnerHeaderNavigation
      : checkValue(spotlightPageData)
      ? spotlightPageData?.partnerHeaderNavigation
      : checkValue(conciergePageData)
      ? conciergePageData?.partnerHeaderNavigation
      : '';

    if (!checkValue(partnerHeaderNavigation, true)) {
      partnerHeaderNavigation = checkValue(cpCmsLitePageData)
        ? cpCmsLitePageData?.partnerHeaderNavigationItems
        : checkValue(spotlightPageData)
        ? spotlightPageData?.partnerHeaderNavigationItems
        : checkValue(conciergePageData)
        ? conciergePageData?.partnerHeaderNavigationItems
        : '';
    }

    return partnerHeaderNavigation;
  };

  const randomOrderNavItems = checkValue(cpCmsLitePageData)
    ? cpCmsLitePageData?.partnerHeaderNavigationRandom
    : checkValue(spotlightPageData)
    ? spotlightPageData?.partnerHeaderNavigationRandom
    : checkValue(conciergePageData)
    ? conciergePageData?.partnerHeaderNavigationRandom
    : '';

  const burgerMenueNavData = getBurgerMenuNavData();

  const {
    subHeaderHamburgerMenuBackgroundColor,
    subHeaderHamburgerMenuBackgroundHoverColor,
    subHeaderHamburgerMenuIconColor,
    subHeaderHamburgerMenuTextColor,
    subHeaderHamburgerMenuTextHoverColor,
    subHeaderHamburgerMenuBackgroundSelectedColor,
    subHeaderHamburgerMenuStyle
  } = getStore(); 

  const handleMenuClick = useCallback(() => {
    setIsWhowMenu((previsWhowMenu) => !previsWhowMenu);
  }, []);

  const currentPath = getURLPath(window.location.href, 'end');
  const getMenuItems = () => {
    const menuItemsArr = [];

    if (checkValue(burgerMenueNavData, true)) {
      const navItems = randomOrderNavItems === "True" ?  randamizingNavItems(burgerMenueNavData) : burgerMenueNavData
      const menuItems = navItems.filter((menu) => {
        return menu.module === 'navigationItem' || menu.module === 'navigationItemReuse';
      });

      if (menuItems.length > 0) {
        menuItems?.forEach((mi) => {
          const { navigationItemText, navigationItemUrl, openUrlInNewTab } = mi;
          const openNewTab = checkValue(openUrlInNewTab) && openUrlInNewTab === 'True' ? true : false;
          if (checkValue(navigationItemText) && checkValue(navigationItemUrl)) {
            const menuPath = getURLPath(navigationItemUrl, 'end');
            const menuItemData = {
              attributes: { role: 'menuitem', tabindex: 0 },
              className: `uitk-list-item ${menuPath === currentPath ? 'selected' : ''}`,
              href: navigationItemUrl,
              label: <span dangerouslySetInnerHTML={{ __html: navigationItemText }} />,
              typeAnchor: true,
              target: openNewTab ? '_blank' : '_self',
            };
            menuItemsArr.push(menuItemData);
          }
        });
      }
    }

    return menuItemsArr;
  };

  const menuItems = getMenuItems();

  const moduleCss = () => {
    const iconColor = checkValue(subHeaderHamburgerMenuIconColor) ? subHeaderHamburgerMenuIconColor : '#ffffff';
    const menuBckColor = checkValue(subHeaderHamburgerMenuBackgroundColor) ? subHeaderHamburgerMenuBackgroundColor : '';
    const menuTxtColor = checkValue(subHeaderHamburgerMenuTextColor) ? subHeaderHamburgerMenuTextColor : '#000000';
    const menuBckHoverColor = checkValue(subHeaderHamburgerMenuBackgroundHoverColor)
      ? subHeaderHamburgerMenuBackgroundHoverColor
      : '#CF8628';
    const menuBckSelectedColor = checkValue(subHeaderHamburgerMenuBackgroundSelectedColor)
      ? subHeaderHamburgerMenuBackgroundSelectedColor
      : checkValue(subHeaderHamburgerMenuBackgroundHoverColor) ? subHeaderHamburgerMenuBackgroundHoverColor :'#F6F6F6';
    const menuTxtHoverColor = checkValue(subHeaderHamburgerMenuTextHoverColor)
      ? subHeaderHamburgerMenuTextHoverColor
      : '#ffffff';
      const menuTxtSelectedColor = checkValue(subHeaderHamburgerMenuBackgroundSelectedColor)
      ? menuTxtColor
      : menuTxtHoverColor;

    return `
            
            .sub-header-menu {
                .uitk-menu-icon-trigger{
                    .uitk-icon{
                        fill: ${iconColor} !important;
                    }
                }

                .uitk-menu-container{
                     background-color: ${menuBckColor} !important;
                    .uitk-list{
                        .uitk-list-item{
                            color: ${menuTxtColor} !important;
                            &:hover{
                                background-color: ${menuBckHoverColor} !important;
                                color: ${menuTxtHoverColor} !important;
                            }
                            &.selected{
                                background-color: ${menuBckSelectedColor} !important;
                                color: ${menuTxtSelectedColor} !important;
                            }
                        }
                    }
                }
            }
        `;
  };

  const subHeaderHamburgerMenuStyleClass =
    subHeaderHamburgerMenuStyle === 'Pill-highlight' ? 'sub-header-menu-pill-highlight' : '';
    
  return (
    <>
      <Layout
        HtmlTag="div"
        css={css`
          ${moduleCss()}
        `}
        className={`${subHeaderHamburgerMenuStyleClass}`}
      >
        {checkValue(menuItems, true) ? (
          <UitkMenu id="bMenu" isOpen={isWhowMenu} onTriggerClick={() => handleMenuClick()} className="sub-header-menu">
            <UitkMenuTrigger>
              <UitkMenuIconTrigger
                className="custom-trigger-class"
                iconSize={UitkIconSize.MEDIUM}
                icon={menuIcon}
                iconTitle="menu"
                iconId="account-menu-icon-list-item"
              />
            </UitkMenuTrigger>
            <UitkMenuContainer position={PositionType.LEFT}>
              <UitkMenuList items={menuItems} />
            </UitkMenuContainer>
          </UitkMenu>
        ) : null}
      </Layout>
    </>
  );
};
